import React, { createContext, PropsWithChildren } from 'react'
import { PageQuery } from '@gql'

export type PageProps = PageQuery

export const ProdPageContext = createContext<{prodPageId:string}>({
  prodPageId:'',
})

export const isTopComponentContext = createContext<{isTopComponent:boolean}>({
  isTopComponent:false,
})

export const ProductListing: React.FC<PropsWithChildren<PageProps>> = () => {
  return null
}
